var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergency2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.108 15.0001L11.4414 3.33344C11.296 3.07694 11.0852 2.8636 10.8305 2.71516C10.5757 2.56673 10.2862 2.48853 9.99136 2.48853C9.69654 2.48853 9.40699 2.56673 9.15226 2.71516C8.89753 2.8636 8.68673 3.07694 8.54136 3.33344L1.8747 15.0001C1.72777 15.2546 1.65072 15.5434 1.65137 15.8372C1.65202 16.131 1.73035 16.4195 1.8784 16.6733C2.02646 16.9271 2.23899 17.1373 2.49444 17.2825C2.7499 17.4277 3.0392 17.5027 3.33303 17.5001H16.6664C16.9588 17.4998 17.246 17.4226 17.4991 17.2762C17.7522 17.1298 17.9624 16.9193 18.1085 16.666C18.2545 16.4127 18.3314 16.1254 18.3313 15.833C18.3312 15.5406 18.2542 15.2533 18.108 15.0001Z",
    stroke: "#DC2626",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V10.8333",
    stroke: "#DC2626",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667H10.0083",
    stroke: "#DC2626",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency2);
export default __webpack_public_path__ + "static/media/Emergency2.84a9d20f91fe06cdfcf68dc07065f06b.svg";
export { ForwardRef as ReactComponent };